import React, { useEffect, useState, useMemo } from "react";

export const Avis = ({ data }) => {
    const [avis, setAvis] = useState([]);
    const [status, setStatus] = useState("loading"); // loading | error | success
    const [showAll, setShowAll] = useState(false);

    const url = useMemo(() => {
        if (!data) return null;
        return `https://api.opinionsystem.fr/v2/client/company/survey?company_id=${data.CompanyID}&api_key=${data.Key}`;
    }, [data]);

    useEffect(() => {
        if (!url) return;

        const controller = new AbortController();

        const fetchAvis = async () => {
            try {
                const res = await fetch(url, { signal: controller.signal });
                if (!res.ok) throw new Error("Fetch error");

                console.log(res)
                const json = await res.json();
                setAvis(json.company_survey ?? []);
                setStatus("success");
            } catch (err) {
                console.log(err)
                if (err.name !== "AbortError") {
                    setStatus("error");
                }
            }
        };

        fetchAvis();

        return () => controller.abort();
    }, [url]);

    const renderContent = () => {
        if (status === "loading") {
            return <p>Chargement des avis…</p>;
        }

        if (status === "error") {
            return <p>Impossible de charger les avis.</p>;
        }

        if (avis.length === 0) {
            return <p>Aucun avis disponible.</p>;
        }

        const sortedAvis = [...avis]
            .sort((a, b) => new Date(b.answer) - new Date(a.answer));

        const displayedAvis = showAll
            ? sortedAvis
            : sortedAvis.slice(0, 12);

        return (
            <>
                <div className="avis-grid">
                    {displayedAvis.map((d, i) => {
                        const date = new Date(d.answer);

                        return (
                            <div key={`${d.name}-${i}`} className="avis-item">
                                <div className="testimonial">
                                    <div className="testimonial-content">
                                        <p>"{d.comment?.trim()}"</p>
                                        <div className="testimonial-meta">
                                            – {d.name} – {date.toLocaleDateString("fr-FR")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {avis.length > 12 && (
                    <div className="avis-button">
                        <button
                            className="btn btn-custom"
                            onClick={() => setShowAll(!showAll)}
                        >
                            {showAll ? "Voir moins" : "Voir plus"}
                        </button>
                    </div>
                )}
            </>
        );
    };

    return (
        <div id="avis">
            <div className="container">
                <div className="section-title text-center">
                    <h2>Avis</h2>
                </div>
                <div className="avis-content">{renderContent()}</div>
            </div>
        </div>
    );
};
